import React from 'react'
import Popover from '@cloudscape-design/components-themed/popover'

// https://cloudscape.design/components/popover
export function RadPopover ({ dismissButton, ...rest }) {
  return (
    <Popover
      dismissButton={dismissButton ?? false}
      {...rest}
    />
  )
}
